<template>
  <!-- 头部start -->
  <div class="header">
    <div class="min header-list">
      <div class="header-left" v-for="(logo,index) in logoList" :key="index">
        <div class="header-icon">
          <img :src="baseURL+logo.Pic" alt />
        </div>

      </div>

      <div class="header-right" >
        <ul>
          <li
            v-for="(arr,index) in arrList"
            :class="{active: index==activeIndex}"
            :key="arr.id"
            @click.prevent="change(arr,index)"
          >{{arr.Name}}</li>
          <li @click.prevent = "onlineShow">在线参观</li>
           <li class="header-line"></li>
          <li class v-if="Status"  >
            <span style="font-size:17px;color:#0078ff" @click="remove">退出</span>
          </li>

          <li class v-else>
            <router-link to="/enters">
              <img src="../../static/img/account.png" alt class="header-account" />
              登录
            </router-link>
          </li>
        </ul>
      </div>

    </div>
  </div>
  <!-- 头部end -->
</template>

<script>
export default {
  name: 'header',
  inject:['reload'],
  props: {
    activeIndex: {
      type: Number,
      default: 0
    }
  },

  data: function() {
    return {
      arrList: [],
      logoList: [],
      //  activeIndex:0,//索引
      path: "",
      baseURL:window.SITE_CONFIG.baseUrl+'/yxht',
      Status:""
    };
  },
  created() {
    this.logoListFun();
    this.arrListFun();
  },
  mounted() {
    this.info = JSON.parse(sessionStorage.getItem("info"));
    if(this.info.Id){
      this.Status=true;
    }else{
   this.Status=false;
    }

  },

  methods: {
    remove(){
      sessionStorage.removeItem("info");
      this.reload()
      sessionStorage.clear()
      //  this.$router.push({ path: "/" });
    },
    logoListFun() {
      var that=this;
         var logo=JSON.parse(sessionStorage.getItem('logo'));
         if(logo){
         this.logoList =logo.rows;

         }else{

        this.$http
        .get("yxapi//api/News/GetNewsList", {
          CategoryId: "5f299ae6-a87b-4a62-a8ef-e37f5664de96"
        })
        .then(res => {
         var logo = res.data.Result
         var banner=JSON.parse(logo)
         that.logoList =banner.rows;
          sessionStorage.setItem('logo',logo);



        });
         }

    },
    arrListFun() {
       var that=this;
        var header=JSON.parse(sessionStorage.getItem('header'))
        if(header){
             this.arrList=header
        }else{
       this.$http
        .get("yxapi//api/News/GetCategoriesList", { ParentId: "" })
        .then(res => {
          console.log(res)
        var list= res.data.Result
        var value=JSON.parse(list)
           that.arrList=value

      //  sessionStorage.setItem('header',list)



        });
        }

    },
    change(arr, index) {
      // this.arrListFun();
      console.log(96963, arr);
      this.logoListFun();
      this.arrListFun();
      if (arr.Sort == 1) {
        this.$router.push({ path: "/" });
      } else if (arr.Sort === 2) {
        this.$router.push({ path: "/exhibition" });
      } else if (arr.Sort === 3) {
        this.$router.push({ path: "/preview" });
      } else if (arr.Sort === 4) {
        this.$router.push({ path: "/booking" });
      } else if (arr.Sort === 6) {
        this.$router.push({ path: "/ActivityConsultation" });
      } else if (arr.Sort === 7) {
        this.$router.push({ path: "/services" });
      }
    },
    onlineShow() {
        window.open("https://www.expoon.com/e/ekqmpxe0yp1/panorama/242485", '_blank')
    }
  }
};
</script>

<style  scoped>
.header-line {
  width: 1px;
  height: 12px;
  background: #cdcfd3;
}
.header {
  width: 100%;
  height: 80px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 4, 11, 0.3);
}
.header-list {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-left {
  /* width: 256px; */
  display: flex;
  align-items: center;
}
.header-left .header-icon {
  width: 263px;
  height: 42px;
}
.header-left .header-icon img {
  width: 263px;
  height: 42px;
}
.header-left .header-left-item {
  margin-left: 7px;
}
.header-left .header-title {
  font-size: 22px;
  letter-spacing: 8px;
  text-align: center;
}

.header-left .header-sub-Title {
  font-size: 12px;
}
.header-right {
  float: right;
}
.header-right ul {
  display: flex;
  align-items: center;
  height: 100%;
}
.header-right ul li {
  position: relative;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin-left: 45px;
  transition: 2s;
  cursor: pointer;
}
.header-right ul li.border {
  height: 80px;
  line-height: 80px;
  /* padding-bottom: 45px;
  border-bottom: 2px solid #0078FF; */
}

.header-right ul li.active {
  color: #0078ff;
  /* font-weight: bold; */
}
.header-right ul li.active:after {
  position: absolute;
  content: '';
  left: 0;
  bottom: -28px;
  width: 100%;
  height: 3px;
  background: #0078ff;
  border-radius: 1px;
}
.header-right ul li a {
  color: #000000;
}
.header-login {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.header-account {
  width: 14px;
  height: 14px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue